import { useApi } from '@/api';
import { LinkButton, Page, PageSkeleton } from '@/components';
import { useSearchParams } from '@/hooks';
import { Box, Flex, Heading } from '@blockanalitica/ui';
import CollateralShareChart from './CollateralShareChart';
import FarmKpi from './FarmKpi';
import GroupDistribution from './GroupDistribution';
import PEKpi from './PEKpi';
import RevenueCard from './RevenueCard';
import SavingsKpi from './SavingsKpi';
import TotalSupplyKpi from './TotalSupplyKpi';
// import StusdsKpi from './STUSDSKpi';
// import InfoBanner from './InfoBanner';

export default function HomePage() {
  const [daysAgo] = useSearchParams('days_ago', '1');
  const [data, error] = useApi({
    url: '/overall/',
    queryParams: {
      days_ago: daysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    const restrictedSection = (
      <>
        {
          // @ts-ignore
          import.meta.env.VITE_PUBLIC_RESTRICTED_BUILD !== 'true' ? (
            <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
              <Flex flexBasis="100%">
                <Flex gap="m" flexBasis="100%" flexDirection="column">
                  <SavingsKpi days_ago={daysAgo} />
                  <FarmKpi days_ago={daysAgo} />
                  {/* <StakingKpi days_ago={daysAgo} /> */}
                  <PEKpi
                    skyPrice={data.sky_price}
                    skyMarketCap={
                      data.total_circulating_sky_supply * data.sky_price
                    }
                  />
                </Flex>
              </Flex>

              <Flex flexBasis="100%" flexDirection="column" alignItems="center">
                <Flex
                  justifyContent="space-between"
                  alignItems="center"
                  width="100%"
                  paddingBottom="xs">
                  <Box flex="1"></Box>
                  <Heading size="3">Collateral Diversification</Heading>
                  <Flex flex="1" justifyContent="flex-end">
                    <LinkButton variant="secondary" to="collateral">
                      view all
                    </LinkButton>
                  </Flex>
                </Flex>
                <CollateralShareChart type="debt" />
              </Flex>
            </Flex>
          ) : (
            <GroupDistribution />
          )
        }
      </>
    );

    return (
      <Flex flexDirection="column" gap="s">
        <Page>
          <Flex>
            <TotalSupplyKpi daysAgo={daysAgo} />
          </Flex>

          {restrictedSection}

          <RevenueCard />
        </Page>
      </Flex>
    );
  }
  return <PageSkeleton />;
}
